import React from 'react'
import { useTranslation } from 'react-i18next'
import WorkersByGroupChartCard from 'components/common/WorkersByGroupChartCard'

const WorkersSection = ({ leamData, workdayData, previousDate }) => {
  const { t } = useTranslation()
  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4'>
      <WorkersByGroupChartCard
        data={leamData.workersByGroupYesterday}
        totalWorkers={workdayData.totalWorkers}
        title={t('dashboard.leam.workersByGroupYesterday')}
        cardColor='green'
        currentDate={previousDate}
      />
      <WorkersByGroupChartCard
        data={workdayData.workersByGroup}
        totalWorkers={workdayData.totalWorkers}
        title={t('dashboard.leam.workersByGroupToday')}
        cardColor='green'
        currentDate={workdayData.currentDate}
      />
    </div>
  )
}

export default WorkersSection
